import { NgModule } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { PanelComponent } from './panel.component';

@NgModule({
  declarations: [PanelComponent],
  imports: [PanelModule],
  exports: [PanelModule, PanelComponent],
})
export class PanelComponentModule {}
